import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const DotRedIcon = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg width={12} height={12} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" focusable="false" ref={ref} {...props}><circle cx={6} cy={6} r={5.5} fill="#FFDCDF" stroke="#FFDCDF" /></svg>;
const ForwardRef = forwardRef(DotRedIcon);
export default ForwardRef;